import * as React from "react";
const SvgAccept = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 13, viewBox: "0 0 18 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17 1L6 12L1 7", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgAccept;
